import { Component, OnInit, ViewChild } from '@angular/core';
import { HeaderData } from '../../_models/header-data';
import { Router, ActivatedRoute } from '@angular/router';
import { RenewalsService } from '../_services/renewals.service';
import { DICE_RENEWALS_CONFIG, RESULTS_NOT_FOUND } from '../../_common/product-config';
import { RenewalStatus, BillingType, StatusCode, BillingStatus, RenewalNotices, Modules } from '../../_common/_enum/module.enum';

@Component({
  selector: 'app-manage-renewals',
  templateUrl: './manage-renewals.component.html',
  styleUrls: ['./manage-renewals.component.scss']
})
export class ManageRenewalsComponent implements OnInit {
  //Create HeaderData object to show the Data on Blue Header.
  private headerData:HeaderData;
  private bannerMsgs = DICE_RENEWALS_CONFIG.BannerMessages;
  private diceRenewalStatusEnum = RenewalStatus;
  private resultsNotFound = RESULTS_NOT_FOUND;
  private loading: boolean = false;
  private hasAccess: boolean = true;
  private billingTypeEnum = BillingType;
  private renewalNoticesEnum = RenewalNotices;

  private renewalNumber: any;
  private accountNumber: any;
  private renewalAccountData: any;
  private renewalDetails: any;
  private accountDetails: any;
  private expiringPolicies: any = [];
  private onlineActivities: any = [];
  private reportLoading: boolean = false;
  private todayDate = new Date();

  private showPolicies: boolean = true;   //Used in HTML
  private renewalStatus: any = '';
  private isBindAvailable: boolean = false;
  private showCancelBanner: boolean = false;
  private billingStatusEnum = BillingStatus;

  @ViewChild("lossRunErrorModal", {static: false}) lossRunErrorModal;
  @ViewChild("lossRunMessageModal", {static: false}) lossRunMessageModal;

  constructor(private readonly route: ActivatedRoute, private readonly router: Router, private renewalsService: RenewalsService) { }

  ngOnInit() {
    this.renewalAccountData = this.renewalsService.getRenewalAccountData();
    
    this.route.paramMap.subscribe(params => {
      this.renewalNumber = parseInt(params.get("id"));
      this.accountNumber = parseInt(params.get("accid"));
      //{ accountName: _renewal.accountName, data: { renewalNumber: _renewal.renewalNumber, accountNumber: _renewal.accountNumber } }
      if(this.renewalAccountData.data){
        this.renewalAccountData.data = {renewalNumber: this.renewalNumber, accountNumber: this.accountNumber};
      }else{
        this.renewalAccountData = {data: {renewalNumber: this.renewalNumber, accountNumber: this.accountNumber}};
      }

      this.renewalsService.renewalAccountData = this.renewalAccountData;
    });
    
    /* console.log(this.renewalNumber, ' :: ', this.renewalAccountData.data.renewalNumber);
    console.log(this.renewalNumber === this.renewalAccountData.data.renewalNumber); */

    /* if(!this.renewalAccountData || !this.renewalAccountData.data || this.renewalAccountData.data.renewalNumber !== this.renewalNumber) {
      this.router.navigateByUrl('/renewals');
    } else */ {
      /* Setting Headers Starts */
      this.headerData = new HeaderData();
      
      //this.setHeaderData(this.renewalAccountData.accountName);
      /* Setting Headers Ended */
      //this.fetchRenewalDetails(this.renewalAccountData.data.accountNumber, this.renewalAccountData.data.renewalNumber);
      this.fetchRenewalDetails(this.accountNumber, this.renewalNumber);
    }
  }

  setHeaderData(_pageTitle = ''){
    this.headerData.pageTitle = _pageTitle;
    this.headerData.breadcrumb = [{itemName: "❮ Back to List", itemLink: "../renewals"}];

    this.renewalsService.header = this.headerData;
  }

  fetchRenewalDetails(_accountNumber, _renewalNumber) {
    this.loading = true;
    this.hasAccess = true;
    this.renewalsService.fetchRenewalDetails(_accountNumber, _renewalNumber).subscribe(response => {      
      this.renewalDetails = response;
      if (this.renewalDetails) {
        this.accountDetails = this.renewalDetails.accountAddress;
        this.renewalStatus = this.renewalDetails.renewalStatus.toLowerCase();
        this.expiringPolicies = this.renewalDetails.expiringPolicies;
        this.onlineActivities = this.renewalDetails.activities;
        console.log('this.renewalStatus :: ', this.renewalStatus);

        this.setHeaderData(this.renewalDetails.accountName);
        this.setExpiredFlag();
        this.setIfBindIsAvailable();
        this.showCancelBanner = this.expiringPolicies.some(this.checkPolicyCancelledorPCN);
        console.log('this.showCancelBanner :: ' + this.showCancelBanner);
      }

      console.log('this.renewalDetails :: ', this.renewalDetails);
      this.loading = false;
    },
    error => {
      this.loading = false;
      this.hasAccess = !(error.status == StatusCode.NoAccess);
    });
  }

  /**
   * Below function is used to set expired flag for UI purpose only 
   * Will set renewal expired flag for expiring policies 
   * And set expired flag for Quotes
   ***/
  setExpiredFlag() {
    this.expiringPolicies.forEach(policy => {
      if(policy.renewalProductInstance) {
        let renewalExpiredDate = new Date(policy.renewalProductInstance.renewalEffectiveDate);
        policy.renewalProductInstance.isRenewalExpired = false;
        if(parseInt(renewalExpiredDate.toJSON().replace(/-/g,""),10) < parseInt(this.todayDate.toJSON().replace(/-/g,""),10)) {
          policy.renewalProductInstance.isRenewalExpired = true;
        }

        if(policy.renewalProductInstance && policy.renewalProductInstance.documents) {
          policy.renewalProductInstance.documents.forEach(doc => {
            let docExpiredDate = new Date(doc.dateExpired);
            doc.isDocExpired = false;
            console.log(docExpiredDate, ' :: ', this.todayDate, ' :: ', docExpiredDate < this.todayDate);
            if(docExpiredDate < this.todayDate) {
              doc.isDocExpired = true;
            }
          });
        }
      }
    });
  }

  setIfBindIsAvailable() {
    this.isBindAvailable = null;
    this.expiringPolicies.forEach(policy => {
      if(policy.renewalProductInstance) {
        if(this.isBindAvailable != false && policy.renewalProductInstance.productInstanceStatusGroup === 'Open'){
          this.isBindAvailable = (policy.renewalProductInstance && policy.renewalProductInstance.documents.length > 0) && policy.renewalProductInstance.documents.some(_doc => _doc.docStatus === 'Posted');
        }
      }
    });

    if (this.isBindAvailable == null) this.isBindAvailable = false;
    console.log(' && isBindAvailable :: ', this.isBindAvailable);
  }

  checkPolicyCancelledorPCN(policy) {
    //console.log('policy :: ', policy.billingStatus);
    return policy.billingStatus === BillingStatus.Cancelled_NonPay || policy.billingStatus === BillingStatus.PendingCancellation;
  }

  /*
    * Below Method will be used for new and change request quote
    * _type - need to pass 'start' for new quote and 'change' for updating the quote
  */
  requestQuote(_type) {
    console.log('this.renewalAccountData :: ', this.renewalAccountData);

    //this.renewalsService.renewalAccountData = this.renewalAccountData;
    
    this.router.navigateByUrl("renewals/" + this.renewalNumber + "/" + _type);
  }

  downloadLossRunReport(type: string){
    this.reportLoading = true;
    this.renewalsService.openModal('none', this.lossRunMessageModal);
    this.renewalsService.downloadLossRunReport(this.renewalDetails.accountNumber, (type+"Number")).subscribe(data=>{
      this.reportLoading = false;
      this.renewalsService.closeModal();
    },
    error => {
      this.reportLoading = false;
      let hasOpenModals = this.renewalsService.hasOpenModals();
      if (hasOpenModals) {
        this.renewalsService.closeModal();
      }
      if(error.status == StatusCode.NoAccess) {        
        setTimeout(() => {
          this.renewalsService.openModal('none', this.lossRunErrorModal);
        }, 50);
        
      } 
      
      if(error.status == StatusCode.InternalServer) {
        setTimeout(() => {
          this.renewalsService.openModal('error', 'none');
        }, 50);
      }
      console.warn("Download Loss Run Report Error : " + error);
    });
  }
  get ModuleEnum() {return Modules;}
  downloadDocuments(_docObj, docName) {
   /*  _docObj.accountNumber = 10096620; // this.renewalDetails.accountNumber
    _docObj.id = 6664241; */

    _docObj.isDownloading = true;

    let documentDownloadSubscription = this.renewalsService.downloadDocuments(_docObj.accountNumber, _docObj.documentId, docName).subscribe(response => {
      _docObj.isDownloading = false;
    },
    error => {
      _docObj.isDownloading = false;
      this.renewalsService.openModal('error', 'none');
    });
    this.renewalsService.runningServices.push(documentDownloadSubscription);
  }

  gotoUrl(_type) {
    console.log('this.renewalAccountData :: ', this.renewalAccountData);

    //this.renewalsService.renewalAccountData = this.renewalAccountData;
    
    this.router.navigateByUrl("renewals/" + this.renewalNumber + "/" + _type);
  }

  gotoBind(_renewalNumber) {    
    this.router.navigateByUrl("renewals/" + _renewalNumber + "/bind");
  }
}